// src/components/DestinationCard/DestinationCard.jsx
import React from 'react';
import './DestinationCard.css';
import { formatCurrency } from '../../utils/pricing';
import { Link } from 'react-router-dom';

const DestinationCard = ({ destination }) => {
  const price = destination.price || destination.basePrice || 0;

  return (
    <article className="destination-card simple">
      <Link to={`/destinations/${destination.id}`} className="card-link">
        <div className="card-image-container">
          <img src={destination.image} alt={destination.name} className="card-image" loading="lazy" />
          <span className="card-badge">{destination.location}</span>
        </div>

        <div className="card-content">
          <h3 className="card-title">{destination.name}</h3>
          <p className="card-sub">{destination.short || destination.description || ''}</p>
        </div>

        <div className="card-footer">
          <div className="price-amount">{formatCurrency(price)}</div>
          <div className="details-btn btn btn-outline" aria-hidden>Voir détails</div>
        </div>
      </Link>
    </article>
  );
};

export default DestinationCard;